export default class DataLayer {
  constructor() {
    window.dataLayer = window.dataLayer || [];
    this.data_attributes = document.querySelector("header").dataset;
    this.events = [];
    this.data_object = {};

    // Loop through each attribute
    for(var attribute in this.data_attributes) {
      // If the attribute is a gtm data layer variable
      if(attribute.startsWith("gtmVariable")) {
        var key = attribute.replace("gtmVariable", "");
        var value = this.data_attributes[attribute];
        this.data_object[key] = value;
      }

      // If the attribute is a gtm data layer click event
      if(attribute.startsWith("gtmClickEvent")) {
        var value = this.data_attributes[attribute].split('|');
        var event_class = value[0];
        var event_values = value[1].split(',');

        if(event_class && event_values && document.querySelectorAll('.' + event_class)) {
          document.querySelectorAll('.' + event_class).forEach((event_item) => {
            event_item.addEventListener('click', (event) => {
              event_item.event_values.forEach((value) => {
                if(event.target.dataset['gtmTransaction']) {
                  window.dataLayer.push({
                    'event': value,
                    'transaction': event.target.dataset['gtmTransaction']
                  });
                } else {
                  window.dataLayer.push({
                    'event': value,
                  });
                }
              });
            });
            event_item.event_class = event_class;
            event_item.event_values = event_values;
          });
        }
      }
    }

    // Push the data layer attributes to the data layer if not empty
    if(Object.keys(this.data_object).length > 0) {
      window.dataLayer.push(this.data_object);
    }
  }
}
